import messages from './logout-lang.json';
export default {
	data() {
		return {
			visible: true
		};
	},
	i18n: { messages },
	props: {
		loginUrl: {
			required: true
		},
		type: {
			required: false
		}
	}
};
